import { render, staticRenderFns } from "./OverflowMenu.vue?vue&type=template&id=6dd9512e&scoped=true&"
import script from "./OverflowMenu.vue?vue&type=script&lang=js&"
export * from "./OverflowMenu.vue?vue&type=script&lang=js&"
import style0 from "./OverflowMenu.vue?vue&type=style&index=0&id=6dd9512e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9512e",
  null
  
)

component.options.__file = "OverflowMenu.vue"
export default component.exports